export default {
  data() {
    return {
      disableShiftSelect: false
    }
  },
  methods: {
    assignItemToSelectBtn(selector, item) {
      if (this.$refs[selector]) {
        this.$refs[selector].item = item
      }
    },
  },
}
